import React, { forwardRef } from "react";
import { Row, Col } from "antd";
import { TextAreaItem } from "../../../components/forms/FormItems";
import RadioButtonItem from "../../../components/forms/RadioButtonItem";
import { FormattedMessage } from "react-intl";
import { MetaDataSelect } from "../../../components/forms/AutoCompleteFormItem";
import { SettingsDataSelect } from "../../../components/forms/AutoCompleteFormItem";
import Surface from "../../../components/layouts/Surface";
import FormHeader from "../../../components/forms/FormHeader";
import Spacer from "../../../components/layouts/Spacer";
import ResponsiveItemsWrapper from "../../../components/layouts/ResponsiveItemsWrapper";
import Courses from "./Courses";

const Training = forwardRef((props, ref) => {
  return (
    <div style={{ display: "flex", flexDirection: "column" }} ref={ref}>
      <Surface>
        <FormHeader title={<FormattedMessage id="app.employees.training" />} />
        <Row>
          <Col xs={24} sm={24} md={24} lg={24} xl={20} xxl={20}>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <MetaDataSelect
                  name="education_id"
                  category="employee"
                  metadataName={"education"}
                />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <RadioButtonItem
                  name="certified"
                  category="employee"
                  trueFalse={true}
                />
              </div>
            </ResponsiveItemsWrapper>

            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <TextAreaItem
                  name="qualifications.education"
                  rows={4}
                  category="employee"
                />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <RadioButtonItem
                  name="professional_trustee"
                  category="employee"
                  trueFalse={true}
                />
              </div>
            </ResponsiveItemsWrapper>
          </Col>
        </Row>
      </Surface>
      <Courses />
      <Surface>
        <FormHeader
          title={<FormattedMessage id="app.employees.qualifications" />}
        />
        <Row>
          <Col xs={24} sm={24} md={24} lg={24} xl={20} xxl={20}>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <MetaDataSelect
                  name="care_demands"
                  category="employee"
                  metadataName={"care_demands"}
                  mode="multiple"
                />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <SettingsDataSelect
                  name="languages"
                  category="employee"
                  settingsdataName={"system_tables/languages"}
                  mode="multiple"
                />
              </div>
            </ResponsiveItemsWrapper>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <TextAreaItem
                  name="qualifications.work_experience"
                  rows={2}
                  category="employee"
                />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <TextAreaItem
                  name="qualifications.professions"
                  rows={2}
                  category="employee"
                />
              </div>
            </ResponsiveItemsWrapper>
          </Col>
        </Row>
      </Surface>
    </div>
  );
});

export default Training;
